import DocumentoFirmatoValidoView from "./DocumentoFirmatoValidoView";
import {
    TIPO_REQ_VEICOLO_CRS_REIM,
    TIPO_REQ_VEICOLO_CRS_REIMM_ALBO
} from "../../../utility/common";

export default function DocumentoFirmatoValidoController({
                                                             documento,
                                                         }) {

    function isCertificatoCrsReimm() {
        return documento && (parseInt(documento.id_tipo_certificato) == TIPO_REQ_VEICOLO_CRS_REIMM_ALBO
            || parseInt(documento.id_tipo_certificato) == TIPO_REQ_VEICOLO_CRS_REIM);
    }

    return (
        <DocumentoFirmatoValidoView
            documento={documento}
            isCertificatoCrsReimm={isCertificatoCrsReimm}
            isMotoveicolo={documento && documento.veicolo && documento.veicolo.id_tipo_marca && documento.veicolo.id_tipo_marca == '2'}
        />
    );

}